export type ReservationStatus =
  | 'draft'
  | 'confirmed'
  | 'in_progress'
  | 'completed'
  | 'cancelled';

/** Estados que bloquean disponibilidad de ítems para otras reservas. */
export const BLOCKING_RESERVATION_STATUSES: readonly ReservationStatus[] = [
  'confirmed',
  'in_progress',
] as const;

export type Reservation = {
  id: string;
  companyId: string;
  title: string;
  description: string;
  inventoryItemIds: string[];
  clientName: string;
  startDate: string;
  endDate: string;
  status: ReservationStatus;
  notes: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type ReservationInput = {
  title: string;
  description: string;
  inventoryItemIds: string[];
  clientName: string;
  startDate: string;
  endDate: string;
  status: ReservationStatus;
  notes: string;
};

export const RESERVATION_STATUS_LABELS: Record<ReservationStatus, string> = {
  draft: 'Borrador',
  confirmed: 'Confirmada',
  in_progress: 'En curso',
  completed: 'Completada',
  cancelled: 'Cancelada',
};
